import { initCountdowns } from '../common/countdown';
import '../layouts/default'

import './catalog/catalog'

if (document.querySelector('.js-countdown')) {
    initCountdowns()
}